
<p-steps [model]="items" [activeIndex]="paso" styleClass="steps-custom"></p-steps>
<br>
